var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDominiumDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h12l8 10v14H20L12 20V6Z",
    fill: "none",
    stroke: "#91adff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14h12M20 14v16M12 6l8 8",
    fill: "none",
    stroke: "#91adff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 23,
    fill: "#edf2fa",
    fontFamily: "Arial,sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: -0.6
  }, "dominium", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 12,
    x: 46,
    y: 38,
    letterSpacing: 3
  }, "CHAT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominiumDark);
export default __webpack_public_path__ + "static/media/dominium-dark.ad9ff6e448157c3790a7c515cd9f9bb3.svg";
export { ForwardRef as ReactComponent };